__webpack_require__.p = "//personal-page.staging.it-incubator.ru/";